import "./Info.css"

function Info({darkBG, infoRef}){
    return(
        <div className="search-view-overlay">
            <div className="search-view-content" style={{ backgroundColor: darkBG }} ref={infoRef}>
                <div className="info-content p-4">
                    <h2 className="info-heading">Info</h2>
                    <div className="info-text py-3">
                        <p>Here you'll find info on this app and how to use it 😊</p>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default Info; 